import React, { useRef } from 'react'
import style from './MultipleCarousel.module.scss'

interface IMultipleCarouselProps {
  showNavigation: boolean
  slidesPerView: number
  children: React.ReactNode
}

const OFFSET_CORRECTION = 2

const MultipleCarousel = ({ showNavigation, slidesPerView, children }: IMultipleCarouselProps) => {
  const carouselRef = useRef<HTMLDivElement>(null)
  const scrollLeft = () => {
    const container = carouselRef.current
    if (!container) return
    const scrollAmount = container.clientWidth * (1 / slidesPerView) - OFFSET_CORRECTION
    const newScrollPosition = container.scrollLeft - scrollAmount
    if (newScrollPosition <= 0) {
      container.scrollTo({
        left: container.scrollWidth - container.clientWidth,
        behavior: 'smooth'
      })
    } else {
      container.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      })
    }
  }

  const scrollRight = () => {
    const container = carouselRef.current
    if (!container) return
    const scrollAmount = container.clientWidth * (1 / slidesPerView) - OFFSET_CORRECTION

    const newScrollPosition = container.scrollLeft + scrollAmount
    const maxScroll = container.scrollWidth - container.clientWidth
    if (newScrollPosition >= maxScroll) {
      container.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
    } else {
      container.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className={style.multipleCarousel}>
      {showNavigation && <button className={style.navigationPrev} onClick={scrollLeft} />}
      {showNavigation && <button className={style.navigationNext} onClick={scrollRight} />}
      <div className={style.carousel} ref={carouselRef}>
        {children}
      </div>
    </div>
  )
}

export default MultipleCarousel
